export default {"src":"/_next/static/media/eye_with_square.5f3df9b4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};